module.exports = "/images/CheckSquareOffset.svg";